import axios from 'axios'

let instance = axios.create({
  baseURL: process.env.VUE_APP_TRANSACTION_SERVICE_API
})
// axios.defaults.withCredentials=true;
function request (options) {
  options = setXApiKey(options)
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

function setXApiKey (options) {
  let baseHeader = {}
  // baseHeader = {
  //   'x-api-key': process.env.VUE_APP_TRANSACTION_SERVICE_XAPIKEY
  // }
  options['headers'] = baseHeader
  return options
}

function getParamsUrl (options) {
  let result = '?'
  for (let key in options) {
    if (options[key]) {
      result += (key + '=' + options[key] + '&')
    } else {
      result += (key + '=&')
    }
  }
  if (result[result.length - 1] === '&') {
    result = result.substring(0, result.length - 1)
  }
  return result
}

let api = {
  getTransactionRecords: (type, options) => {
    return request({
      method: 'get', // 请求方式
      url: type + getParamsUrl(options),
      data: options || {}
    })
  }
}
export default api
